import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ModalProvider } from './Context/ModalContext';
import Modal from './Components/Modal/Modal';
import ModalGral from './Components/ModalGral/ModalGral';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ModalProvider>
            <App />
            <Modal />
        </ModalProvider>
    </BrowserRouter>
);